import {Box, Stack, Typography} from "@mui/material";
import {PaymentPackType} from "../types/PaymentPackType";
import coin from "../../../public/coin-svgrepo-com.svg";
import {useGetCurrencyFromPymentProvider} from "../../entities/hooks/useGetCurrencyFromPymentProvider.ts";
import {PaymentProviderEnum} from "../types/PaymentProviderEnum.ts";
import {liquidGlassStyle} from "../../app/theme/liquidGlassStyle.ts";

interface IPaymentPackProps {
    pack: PaymentPackType;
    paymentProvider: PaymentProviderEnum
    onClick: () => void;
}

export const PaymentPack = ({pack, paymentProvider, onClick}: IPaymentPackProps) => {
    const currency = useGetCurrencyFromPymentProvider(paymentProvider);
    return (
        <Box
            onClick={onClick}
            sx={{
                ...liquidGlassStyle,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '16px',
                width: '100%',
                cursor: 'pointer',
                borderRadius: '24px',
                textTransform: 'none',
            }}
        >
            <Stack direction="row" alignItems="center" spacing={1}>
                <Typography sx={{fontWeight: '700', fontSize: '24px'}}>
                    {pack.credits}
                </Typography>
                <Box component="img" src={coin} alt="coin" width="24px" height="24px" />
            </Stack>
            <Typography sx={{fontSize: '16px', opacity: 0.8, marginTop: '8px'}}>
                {pack.price} {currency}
            </Typography>
        </Box>
    );
};
